export default __webpack_public_path__ + "static/media/02_Eschweiler_photographer_Esche_Serum114_Architecture_Interieur_3.066eaab3.jpg";